import { roundNumberAndDecimals } from '@teinor/erp/prices';
import { TwinDictionary } from '../../../../../../utils/globals/dictionary';
import { stringMatchWithExactSearch } from '../../../../../../utils/globals/search';
import { SellOrderPrepareLocalStorageTy, ServedOrderTDTy, typeFieldSearchCompleteTy, TypeFieldSearchTyKeys } from './types';
import { baseCalculateParams } from '@teinor/erp/prices/quote/calculate';
import { OrderData } from '../../../OrderLayout/types';

export const findProductByTypeSearch = (products: TwinDictionary[], ref: string, servedOrderTD: ServedOrderTDTy, typeFieldSearch: TypeFieldSearchTyKeys, WorkSheetProductStatusId?: number) => {
    let result: TwinDictionary | null = null
    if(ref === ''){
        return result
    }
    const fieldSearch = typeFieldSearchCompleteTy[typeFieldSearch]
    const parsedWorkSheetProductStatusId = parseInt(String(WorkSheetProductStatusId))
    for (const element of products) {
        if (element.FirstChildId){
            continue
        }
        const parsedId = element.id
        const myProduct = servedOrderTD.tableData[servedOrderTD.dictPosTableData[parsedId]]
        const myquantity =parseFloat(myProduct?.quantity)
        const mydesired = parseFloat(myProduct?.desiredQuantity)
        let filterWorkSheetProductStatusId = false
        if (WorkSheetProductStatusId ){
            if (element?.WorkSheetStatusParsed?.length){
                let preselected: TwinDictionary | null = null
                for (const status of element?.WorkSheetStatusParsed) {
                    if (status.WorkSheetProductStatusId === parsedWorkSheetProductStatusId ){
                        const diffStatusQuantity = roundNumberAndDecimals(parseFloat(status.quantity) - parseFloat(status.alreadyOrderProcessed), baseCalculateParams)
                        if (diffStatusQuantity <= myquantity || !diffStatusQuantity) {
                            continue
                        }
                        element.quantity = diffStatusQuantity - (myquantity || 0)
                        element.desiredQuantity = diffStatusQuantity
                        element.WorkSheetProductId = status.id
                        if(preselected){
                            element.WorkSheetProductId = [preselected.WorkSheetProductId, status.id]
                            element.quantity = roundNumberAndDecimals(parseFloat(preselected.quantity) + element.quantity, baseCalculateParams)
                            element.desiredQuantity = roundNumberAndDecimals(parseFloat(preselected.desiredQuantity) + element.desiredQuantity, baseCalculateParams)
                        }
                        preselected = JSON.parse(JSON.stringify(element))
                        filterWorkSheetProductStatusId = true
                    }else{
                        continue
                    }
                }
            }
            if (element.WorkSheetProductStatusId){
                if (parsedWorkSheetProductStatusId !== element.WorkSheetProductStatusId) {
                    continue
                } else {
                    filterWorkSheetProductStatusId = true
                }
            } 
        }
        if (!element.processed &&  (WorkSheetProductStatusId ?  WorkSheetProductStatusId && filterWorkSheetProductStatusId : true)){
            let mustContinue = false
            for (const field of fieldSearch) {
                if(stringMatchWithExactSearch(ref, element[field])){
                    mustContinue = true
                    break
                }
            }
            if(mustContinue){
                if (!servedOrderTD.selectedProducts[parsedId]){
                    let quantity = roundNumberAndDecimals(myProduct ? mydesired - myquantity : element.quantity, baseCalculateParams)
                    return {...element, quantity}
                }
                if (parseInt(element?.desiredQuantity) > myquantity){
                    let quantity = roundNumberAndDecimals(myProduct ? mydesired - myquantity : element.quantity, baseCalculateParams)
                    return { ...element,  quantity, alreadyPushed: true }
                }else {
                    result = { completed: true }
                }
            }
        }
    }
    return result
}

export const parseSelectedProductsToUpdate = (tableData: TwinDictionary[]) => {
    const result : TwinDictionary[] = []
    const justIds: TwinDictionary[] = []
    const dictPosResult: TwinDictionary = {}
    for (const product of tableData) {
        const parsedId = product.parsedId || product.id
        if(dictPosResult[parsedId] !== undefined){
            result[dictPosResult[parsedId]].quantity = roundNumberAndDecimals(result[dictPosResult[parsedId]].quantity + parseFloat(String(product.quantity)), baseCalculateParams)
        }else {
            result.push(
                {
                    id: parsedId,
                    OrderId: product.OrderId,
                    quantity: parseFloat(String(product.quantity)),
                    nLine: product.nLine,
                    ProductId: product.ProductId,
                    OrderProductId: product.OrderProductId,
                    isChanging: product.quantity !== product.desiredQuantity,
                    inventPosition: product.inventPosition,
                    taxUsed: product.taxUsed,
                    quantity2: product.quantity2
                }
            )
            if(!dictPosResult[parsedId]){
                dictPosResult[parsedId] = result.length -1
            }
            justIds.push({ id: parsedId })
        }
    }
    return { result, justIds }
}

export const filterTableDataPrepareOrder = (servedOrderTD: ServedOrderTDTy) => {
    const newResult: { dictPosTable: TwinDictionary, tableData: TwinDictionary[] } = {
        dictPosTable: {},
        tableData: []
    }
    if (servedOrderTD.filteredTableData) { 
        for (let index = servedOrderTD.filteredTableData.length; index > 0; index--) {
            const product = servedOrderTD.filteredTableData[index-1]
            const element = servedOrderTD.tableData[servedOrderTD.selectedProducts[product.id].posTableData]
            element.absoluteIndex = index - 1
            newResult.dictPosTable[element.id] = index - 1
            newResult.tableData.push(element)
        }
        return newResult
    }
    for (let index = servedOrderTD.tableData.length; index > 0; index--) {
        const element = servedOrderTD.tableData[index -1]
        element.absoluteIndex = index-1
        newResult.dictPosTable[element.id] = index - 1
        newResult.tableData.push(element)
    }
    return newResult
}

export const getExtraSelectedData = (servedOrderTD: ServedOrderTDTy) => {
    let extraSelectedData: TwinDictionary | null = null
    if (servedOrderTD.tableData?.length){
        const copyTableData= JSON.parse(JSON.stringify(servedOrderTD.tableData))
        for (const product of copyTableData) {
            if (product.WorkSheetProductId) {
                if(!extraSelectedData){
                    extraSelectedData = {}
                }
                if (!extraSelectedData[product.id]){
                    extraSelectedData[product.id] = {}
                }
                if (product.WorkSheetProductId.length){
                    for (const id of product.WorkSheetProductId) {
                        if (product.dictWorkSheetProducts[id]){
                            const diffStatusQuantity = roundNumberAndDecimals(parseFloat(product.dictWorkSheetProducts[id].quantity) - parseFloat(product.dictWorkSheetProducts[id].alreadyOrderProcessed), baseCalculateParams)
                            if (diffStatusQuantity >= product?.quantity){
                                if ((product?.quantity || 0)){
                                    extraSelectedData[product.id] = { ...extraSelectedData[product.id], [id]: (product?.quantity || 0) }
                                    product.quantity = 0
                                }
                            }else {
                                extraSelectedData[product.id] = { ...extraSelectedData[product.id], [id]: diffStatusQuantity }
                                product.quantity = roundNumberAndDecimals((product?.quantity || 0) - diffStatusQuantity, baseCalculateParams)
                            }
                        }
                    }
                }else {
                    extraSelectedData[product.id] = { ...extraSelectedData[product.id], [product.WorkSheetProductId] : product.quantity}
                }
            }
        }
    }
    return extraSelectedData
}

export const parseDataToServedOrderTD = (Order: OrderData) => {
    const result: ServedOrderTDTy = {
        tableData: [], selectedProducts: {}, dictPosTableData: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} }, showRestoreButton: false
    }
    const preSelectedOrderProducts = window.localStorage.getItem(`selectedOrderProducts${Order.header.id}`) || '[]'
    const parsedPreselectedOrderProducts = JSON.parse(preSelectedOrderProducts)

    const copyOrder = JSON.parse(JSON.stringify(Order))
    if(copyOrder?.selectedTableData?.length){
        for (let i = 0; i < copyOrder.selectedTableData.length; i++) {
            const item = copyOrder.selectedTableData[i]
            const product = copyOrder.tableData?.[copyOrder.dictPosTableData?.[item.id]]
            if(product){
                product.absoluteIndex = i
                if (!product?.OrderProductId){
                    result.tableData.push(product)
                    result.dictPosTableData[item.id] = i
                    result.selectedProducts[item.id] = {...product, posTableData: i}
                }
            }
        }      
    }
    if (parsedPreselectedOrderProducts.length){
        result.showRestoreButton = true
    }
    return result
}

export const restoreDataFromLocalStorage = (products: TwinDictionary[], Order: SellOrderPrepareLocalStorageTy, selectedOrderProducts: TwinDictionary, WorkSheetProductStatusId: number | null) => {
    const parsedWorkSheetProductStatusId = parseInt(String(WorkSheetProductStatusId))
    let result: TwinDictionary[] = []
    for (const element of products) {
        const parsedId = element.id
        if(!selectedOrderProducts[element.id]){
            const myProduct = Order.tableData[Order.dictPosTableData[parsedId]]
            if (myProduct.FirstChildId) {
                continue
            }
            const myquantity = parseFloat(element.quantity)
            let filterWorkSheetProductStatusId = false
            if (WorkSheetProductStatusId) {
                if (myProduct?.WorkSheetStatusParsed?.length) {
                    let preselected: TwinDictionary | null = null
                    for (const status of myProduct?.WorkSheetStatusParsed) {
                        if (status.WorkSheetProductStatusId === parsedWorkSheetProductStatusId) {
                            const diffStatusQuantity = roundNumberAndDecimals(parseFloat(status.quantity) - parseFloat(status.alreadyOrderProcessed), baseCalculateParams)
                            filterWorkSheetProductStatusId = true
                            if (diffStatusQuantity <= myquantity || !diffStatusQuantity) {
                                continue
                            }
                            myProduct.quantity = diffStatusQuantity - (myquantity || 0)
                            myProduct.desiredQuantity = diffStatusQuantity
                            myProduct.WorkSheetProductId = status.id
                            if (preselected) {
                                myProduct.WorkSheetProductId = [preselected.WorkSheetProductId, status.id]
                                myProduct.quantity = roundNumberAndDecimals(parseFloat(preselected.quantity) + myProduct.quantity, baseCalculateParams)
                                myProduct.desiredQuantity = roundNumberAndDecimals(parseFloat(preselected.desiredQuantity) + myProduct.desiredQuantity, baseCalculateParams)
                            }
                            preselected = JSON.parse(JSON.stringify(myProduct))
                            filterWorkSheetProductStatusId = true
                        } else {
                            continue
                        }
                    }
                }
                if (myProduct.WorkSheetProductStatusId) {
                    if (parsedWorkSheetProductStatusId !== myProduct.WorkSheetProductStatusId) {
                        continue
                    } else {
                        filterWorkSheetProductStatusId = true
                    }
                }
            }
            if (!myProduct.processed && (WorkSheetProductStatusId ? WorkSheetProductStatusId && filterWorkSheetProductStatusId : true)) {
                let quantity = roundNumberAndDecimals(myquantity, baseCalculateParams)
                result.push( {...myProduct, quantity })
            }
        }      
    }
    return result
}